export default __webpack_public_path__ + "static/media/brake-ratio.fcc321e6.svg";